import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-purchase-confirmation-dialog',
    templateUrl: './purchase-confirmation-dialog.component.html',
    styleUrls: ['./purchase-confirmation-dialog.component.scss'],
    standalone: false
})
/* istanbul ignore next */
export class PurchaseConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { productName: string; subscriptionId: string }
  ) {}
}
